import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth/auth.service';
import { NGXLogger } from 'ngx-logger';
import {ActivatedRoute, Router} from '@angular/router';


const lmsLogoutRouteFlag = 'lms';
@Component({
  selector: 'app-logged-out-dialog',
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
  loginUrl: string;

  constructor(
    private authService: AuthService,
    private logger: NGXLogger,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.loginUrl = this.authService.ssoUrl();
  }

  async ngOnInit(): Promise<void> {
    const routeParam = this.activatedRoute.snapshot.queryParamMap.get('route');
    const shouldRedirect = !(routeParam === lmsLogoutRouteFlag);
    this.logger.debug(`[LogoutComponent] - ngOnInit: routeParam = ${routeParam} | shouldRedirect = ${shouldRedirect}`);

    if (shouldRedirect) {
      const isAuthenticated = await this.authService.isAuthenticated();
      this.logger.debug('[LogoutComponent] - ngOnInit: isAuthenticated: ', isAuthenticated);

      if (isAuthenticated) {
        this.logger.debug('[LogoutComponent] - ngOnInit: starting LogOut');
        await this.authService.logout(shouldRedirect);
      } 
      else {
        this.clearQueryParams();
      }
    }
    else {
      this.logger.debug('[LogoutComponent] - ngOnInit: starting LogOut - no redirect');
      await this.authService.logout(shouldRedirect);
      this.clearQueryParams();
    }
  }

  private clearQueryParams(): void {
    this.logger.debug('[LogoutComponent] - clearQueryParams()');
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: null,
        queryParamsHandling: ''
      });
  }


  // async ngOnInit(): Promise<void> {
  //   const isAuthenticated = await this.authService.isAuthenticated();
  //   this.logger.debug('[LogoutComponent] - ngOnInit: isAuthenticated: ', isAuthenticated);

  //   const routeParam = this.activatedRoute.snapshot.queryParamMap.get('route');
  //   const shouldRedirect = !(routeParam === lmsLogoutRouteFlag);
  //   this.logger.debug(`[LogoutComponent] - ngOnInit: routeParam = ${routeParam} | shouldRedirect = ${shouldRedirect}`);

  //   if (isAuthenticated) {
  //     this.logger.debug('[LogoutComponent] - ngOnInit: starting LogOut');
  //     await this.authService.logout(shouldRedirect);

  //     if (!shouldRedirect) {
  //       await this.authService.isAuthenticated();
  //     }
  //   } else {
  //     this.logger.debug('[LogoutComponent] - ngOnInit: cleaning query params');
  //     this.router.navigate(
  //       [],
  //       {
  //         relativeTo: this.activatedRoute,
  //         queryParams: null,
  //         queryParamsHandling: ''
  //       });
  //   }
  // }
}
